import { makeStyles, Typography } from "@material-ui/core";
import axios from "axios";
import clsx from 'clsx';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AcnColorTheme } from "../../assets/css/AcnColorTheme";
import barcode from '../../assets/img/barcode.png';
import qrcode from '../../assets/img/qricon.png';
import { LoadingWidget } from "../../common/loading/loading_widget";
import TemplateComponent from "../../component/template/TemplateComponent";
import { BillerModel } from "../../models/BillerModel";
import { QrBarCodeModel, QrBarCodeReqModel } from "../../models/QrBarCodeModel";
import { ApiConfig, ServiceApi, StaticContentApi } from "../../service/ServiceApi";
import { RootState } from "../../store";
import { NavTo } from "../../utils/AppManager";
import { Path } from "../../utils/Constant";
import { currencyFormat } from "../../utils/CurrencyManager";
import { heightUnit, padGinUnit, widthUnit } from "../../utils/DeviceManager";

const React = require('react');
const QRCode = require('qrcode.react');
const Barcode = require('react-barcode');

const logoPath = {
    bbl: "/images/bbl.png",
    bigc: "/images/bigc.png",
    chaiyo: "/images/chaiyo.png",
    counterservice: "/images/counterservice.png",
    kbank: "/images/kbank.png",
    ktb: "/images/ktb.png",
    lotus: "/images/lotus.png",
    scb: "/images/scb.png",
    themall: "/images/themall.png",
    krungsri: "/images/krungsri.png"
}

export function QrBarcode() {
    const classes = useStyles();
    const [code, setCode] = useState<QrBarCodeModel>({ rawPayload: "", barcodeBase64Payload: "", qrBase64Payload: "" })

    const [billInfo] = useSelector((state: RootState) => [
        state.billerReducer.billInfo,
    ]);

    const [serviceProvider, setServiceProvider] = useState('');


    useEffect(() => {
        generateCode(billInfo).then(() => {
            console.log("generating..")
        })
        getServiceProvider();
    }, [billInfo])

    useEffect(() => {
        document.title = "ชำระเงิน\u200E\u200E"
    }, [])

    const dynamicQr = (payloadLength: number) => {
        const okLength = 30
        if (payloadLength <= okLength) return 2;

        const lvl = 1 / payloadLength;
        const properLength = lvl * 100
        if (properLength >= 2) return 2;
        return properLength * 0.75
    }

    const getServiceProvider = async () => {
        const res = await axios.get(StaticContentApi.SERVICE_PROVIDER)
        setServiceProvider(res.data.name);
    }

    const getLogoPath = (logoPath: string) => {
        return `${StaticContentApi.PAYMENT_CHANNEL}${logoPath}`;
    }

    const generateCode = async (bill: BillerModel) => {
        const request: QrBarCodeReqModel = {
            billerCodeId: bill.billerCodeId,
            ref1: bill.ref1,
            ref2: bill.ref2,
            amount: bill.customAmount.toString()
        }
        axios.post(ServiceApi.CODE_GENERATE, request, ApiConfig)
            .then((res) => {
                return res;
            }).then(data => {
                const response: QrBarCodeModel = data.data
                setCode(response)
                // console.log(response);

            })
            .catch(error => {
                const errorStr = JSON.stringify(error)
                console.log(errorStr)
                NavTo(Path.expired.replace(":msg", "ขออภัย ไม่สามารถแสดงผลลัพธ์ได้ในขณะนี้ กรุณาลองอีกครั้ง")) //TLMSIT-7550
            })
    }

    const [isQr, setIsQr] = useState(true)

    const qrWidget = () => {
        return (
            <div className={classes.root}>
                <div className={clsx(classes.content, !isQr && classes.rotate90)}>
                    <Typography className={classes.textQr} data-testid="textQr">
                        สแกน QR/Barcode เพื่อชำระเงิน
                    </Typography>
                    <div className={clsx(classes.detail, !isQr && classes.barcodeContent)}>
                        {
                            isQr ? (
                                <div style={{ margin: padGinUnit(48) }}>
                                    <QRCode value={code.rawPayload} size={widthUnit(250)} />
                                </div>
                            ) : (
                                <div style={{
                                    marginTop: padGinUnit(24),
                                    transform: code.rawPayload.length >= 35 ? 'scale(0.8)' : 'scale(0.9)',
                                    alignSelf: 'center',
                                }}>
                                    <Barcode value={`${code.rawPayload}`}
                                        height={heightUnit(168)}
                                        width={widthUnit(dynamicQr(code.rawPayload.length))}
                                        font="Helvetica"
                                        style={{ fontSize: 10 }} />
                                </div>
                            )
                        }

                        <Typography
                            onClick={() => { setIsQr(!isQr) }}
                            className={classes.changeQr}
                            variant="h6"
                        >
                            <img src={isQr ? barcode : qrcode}
                                alt='barcode'
                                style={{
                                    height: '24px',
                                    verticalAlign: 'middle',
                                    paddingRight: '8px'
                                }}
                            />
                            <span>กดเพื่อเปลี่ยนเป็น </span>
                            {isQr ? "Barcode" : "QR code"}
                        </Typography>

                        <div className={classes.paymentDetail}>
                            <Typography className={classes.paymentText}>
                                ยอดชำระ: {currencyFormat(billInfo.customAmount)}
                            </Typography>
                            <Typography className={classes.paymentText}>
                                ผู้ให้บริการ: {serviceProvider}
                            </Typography>
                            <Typography className={classes.paymentText} style={{ flex: isQr ? undefined : '50%' }}>
                                หมายเลขอ้างอิง: {billInfo.ref1}
                            </Typography>
                        </div>
                    </div>
                </div>
                <div className={classes.footer}>
                    <Typography align="left" className={classes.paymentText} style={{ paddingBottom: '16px' }}>
                        ชำระเงินค่างวดง่ายๆ หลายหลายช่องทาง
                    </Typography>
                    <div className={classes.logoContainer}>
                        <img className={classes.image} src={getLogoPath(logoPath.chaiyo)} alt="chaiyo logo" />
                        <img className={classes.image} src={getLogoPath(logoPath.scb)} alt="scb logo" />
                        <img className={classes.image} src={getLogoPath(logoPath.counterservice)} alt="counterservice logo" />
                    </div>
                    <div className={classes.logoContainer}>
                        <img className={classes.image} src={getLogoPath(logoPath.ktb)} alt="ktb logo" />
                        <img className={classes.image} src={getLogoPath(logoPath.krungsri)} alt="krungsri logo" />
                    </div>
                    <div className={classes.logoContainer}>
                        <img className={classes.image} src={getLogoPath(logoPath.bbl)} alt="bbl logo" />
                        <img className={classes.image} src={getLogoPath(logoPath.bigc)} alt="bigc logo" />
                        <img className={classes.image} src={getLogoPath(logoPath.lotus)} alt="lotus logo" />
                    </div>
                </div>
            </div >
        )
    }

    return <TemplateComponent noPadding content={code.rawPayload.length > 0 ? qrWidget() : LoadingWidget()} />

}

const useStyles = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        overflowY: 'scroll',
        overflowX: 'hidden',
        width: '100%',
        height: 'calc(100vh - 32px)',
        // height: 'auto',
        backgroundColor: "white",
        position: "absolute",
        top: "1"
    },
    content: {
        backgroundColor: "white",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: '24px',
        height: window.innerHeight,
        alignItems: 'center',
    },
    rotate90: {
        transform: 'rotate(90deg) translate(-30%, 0)',
        justifyContent: 'center',
        alignItems: 'unset',
        height: 0,
        minHeight: '87%'
    },
    detail: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 'fit-content'
    },
    barcodeContent: {
        alignItems: 'unset'
    },
    qr: {
        alignItems: 'center',
    },
    textQr: {
        fontFamily: 'Prompt',
        fontSize: '16px',
        fontWeight: 'bold',
        alignSelf: 'flex-start',
    },
    textBarcode: {
        fontFamily: 'Prompt',
        fontSize: '18px',
        fontWeight: 'bold',
        paddingBottom: '8px',
        paddingLeft: "8%",
        paddingRight: "8%"
    },
    changeQr: {
        // alignSelf: 'center',
        color: AcnColorTheme.darkBlue,
        fontSize: '18px',
        fontWeight: 600
    },
    image: {
        height: 56,
        paddingRight: '8px',
        '&:last-child': {
            paddingRight: 0
        }
    },
    logoContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 8,
        '&:last-child': {
            marginBottom: 0
        }
    },
    footer: {
        padding: '16px 24px',
        backgroundColor: AcnColorTheme.grey100
    },
    paymentDetail: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '16px',
        textAlign: 'left',
        flexWrap: 'wrap',
    },
    paymentText: {
        fontSize: '14px',
        fontFamily: 'Prompt-Regular, Helvetica, Roboto, sans-serif',
    },
})